import { render } from "./Main.vue?vue&type=template&id=e1848658&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=e1848658&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e1848658"

export default script